import * as React from 'react';
import { safe, exportToCsv, getbaseURL, downloadPDF, addItemToGoogleTracking, isNullOrUndefined, } from "../../utils";
import { toggleModal } from "../../actions";
import { IExplorerProperties, IModals } from "../../models";
const styles = require('./HistoricalPricesModal.pcss');
const FaAngleRight = require('react-icons/lib/fa/angle-right');
const FaClose = require('react-icons/lib/fa/close');
const moment = require('moment');
const Datetime = require('react-datetime');

/*--- Interfaces ---*/

interface IProps {
    modals?: IModals;
    toggleModal?: typeof toggleModal;
}

interface IState {
    startDate?: string;
    endDate?: string;
}

export class HistoricalPricesModal extends React.Component<IProps & IExplorerProperties, IState>{
    constructor(props) {
        super(props);
        this.state = {
            startDate: "",
            endDate: ""
        };

        this.hide = this.hide.bind(this);
        this.setStartDate = this.setStartDate.bind(this);
        this.setEndDate = this.setEndDate.bind(this);
        this.downloadPdf = this.downloadPdf.bind(this);
        this.exportCSV = this.exportCSV.bind(this);
        this.checkDate = this.checkDate.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let { shareClass } = nextProps.modals;
        if (shareClass) {
            this.setStartDate(moment(shareClass.properties["launch_date"]));
            this.setEndDate(moment());
        }
    }

    hide() {
        this.props.toggleModal();
    }

    setStartDate(date) {
        this.setState({ startDate: date });
    }

    setEndDate(date) {
        this.setState({ endDate: date });
    }

    downloadPdf(event, type) {
        event.preventDefault();

        let startDate = "";
        let endDate = "";

        let { appParams, sorting, modals } = this.props;
        let { clienttype, language, productrange, region, _location, sort } = appParams;
        let { sortOrder } = sorting;
        let { shareClass } = modals;
        let isin = shareClass.clientCode;
        let filename = "";

        let historicalSharePricesData = shareClass.timeseries.filter(item => item.code === "historical_share_prices");
        let historicalNavData = shareClass.timeseries.filter(item => item.code === "historical_nav_prices");
        let clientCode = shareClass.properties.fund_key;
        let clientCodeList = ['CIIT'];
        let clientTypes;
        let clientTypeCheck;
        let clientTypesList = ['Discretionary Wealth', 'Independent Financial Advisor'];
        if (clientCodeList.indexOf(clientCode) > -1) {
            clientTypes = shareClass.properties.client_types;
            clientTypeCheck = clientTypesList.some(values => clientTypes.indexOf(values) > -1);
        }
        
        let url;
        let baseUrl = getbaseURL();

        if (!isNullOrUndefined(historicalSharePricesData) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck){
            if (type === "custom") {
                filename = `Historical-Share-Prices-${ shareClass.clientCode }-${ moment(this.state.startDate).format("YYYY-MM-DD") }-to-${ moment(this.state.endDate).format("YYYY-MM-DD") }`;
                startDate = moment(this.state.startDate).format("YYYY-MM-DD");
                endDate = moment(this.state.endDate).format("YYYY-MM-DD");
            }
            if (type === "lastMonth") {
                filename = `Historical-Share-Prices-${ shareClass.clientCode }-Last-Month`;
                startDate = moment().subtract(1, "day").subtract(1, "month").format("YYYY-MM-DD");
                endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
            if (type === "sixMonths") {
                filename = `Historical-Share-Prices-${ shareClass.clientCode }-Last-Six-Months`;
                startDate = moment().subtract(1, "day").subtract(6, "month").format("YYYY-MM-DD");
                endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
            }

            url = `${ baseUrl }historical-share-prices-pdf/${ sortOrder }/${ isin }/${ startDate }/${ endDate }/${ productrange }/${ region }/${ clienttype }/${ language }`;

        } else if (!isNullOrUndefined(historicalNavData) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck) {
                if (type === "custom") {
                    filename = `Historical-Nav-Prices-${ shareClass.clientCode }-${ moment(this.state.startDate).format("YYYY-MM-DD") }-to-${ moment(this.state.endDate).format("YYYY-MM-DD") }`;
                    startDate = moment(this.state.startDate).format("YYYY-MM-DD");
                    endDate = moment(this.state.endDate).format("YYYY-MM-DD");
                }
                if (type === "lastMonth") {
                    filename = `Historical-Nav-Prices-${ shareClass.clientCode }-Last-Month`;
                    startDate = moment().subtract(1, "day").subtract(1, "month").format("YYYY-MM-DD");
                    endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
                }
                if (type === "sixMonths") {
                    filename = `Historical-Nav-Prices-${ shareClass.clientCode }-Last-Six-Months`;
                    startDate = moment().subtract(1, "day").subtract(6, "month").format("YYYY-MM-DD");
                    endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
                }
    
                url = `${ baseUrl }historical-nav-prices-pdf/${ sortOrder }/${ isin }/${ startDate }/${ endDate }/${ productrange }/${ region }/${ clienttype }/${ language }`;
        } else {
            if (type === "custom") {
                filename = `Historical-Prices-${ shareClass.clientCode }-${ moment(this.state.startDate).format("YYYY-MM-DD") }-to-${ moment(this.state.endDate).format("YYYY-MM-DD") }`;
                startDate = moment(this.state.startDate).format("YYYY-MM-DD");
                endDate = moment(this.state.endDate).format("YYYY-MM-DD");
            }
            if (type === "lastMonth") {
                filename = `Historical-Prices-${ shareClass.clientCode }-Last-Month`;
                startDate = moment().subtract(1, "day").subtract(1, "month").format("YYYY-MM-DD");
                endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
            if (type === "sixMonths") {
                filename = `Historical-Prices-${ shareClass.clientCode }-Last-Six-Months`;
                startDate = moment().subtract(1, "day").subtract(6, "month").format("YYYY-MM-DD");
                endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
        }

        url = `${ baseUrl }historical-prices-pdf/${ sortOrder }/${ isin }/${ startDate }/${ endDate }/${ productrange }/${ region }/${ clienttype }/${ language }`;
        addItemToGoogleTracking(appParams, "fund_historic_prices_ppl", { eventCategory: shareClass.clientCode, eventLabel: `pdf-${type}` });

        downloadPDF(url, filename);
        this.props.toggleModal();
    }

    exportCSV(event, type) {
        event.preventDefault();

        let rows = [];
        let filename = "";
        let startDate = "";
        let endDate = "";

        let { appParams, modals } = this.props;
        let { shareClass } = modals;

        let historicalSharePricesData = shareClass.timeseries.filter(item => item.code === "historical_share_prices");
        let historicalNavData = shareClass.timeseries.filter(item => item.code === "historical_nav_prices");
        let clientCode = shareClass.properties.fund_key;
        let clientCodeList = ['CIIT'];
        let clientTypes;
        let clientTypeCheck;
        let clientTypesList = ['Discretionary Wealth', 'Independent Financial Advisor'];
        if (clientCodeList.indexOf(clientCode) > -1) {
            clientTypes = shareClass.properties.client_types;
            clientTypeCheck = clientTypesList.some(values => clientTypes.indexOf(values) > -1);
        }

        let historicalPrices;
        if (!isNullOrUndefined(historicalSharePricesData) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck){
            historicalPrices = shareClass.timeseries.filter(item => item.code === "historical_share_prices");
        } else if(!isNullOrUndefined(historicalNavData) && (clientCodeList.indexOf(clientCode) > -1) && clientTypeCheck){
            historicalPrices = shareClass.timeseries.filter(item => item.code === "historical_nav_prices");
        } else {
            historicalPrices = shareClass.timeseries.filter(item => item.code === "historical_prices");
        }

        let csvHeadings;
        if (!isNullOrUndefined(historicalNavData) && historicalNavData.length > 0){
            csvHeadings = ["Fund Name", "Share Class", "Currency", "ISIN", "Date", "NAV Price"];
        } else {
            csvHeadings = ["Fund Name", "Share Class", "Currency", "ISIN", "Date", "Price", "Bid Price", "Offer Price"];
        }
        
        if (!isNullOrUndefined(historicalSharePricesData) && clientCodeList.indexOf(clientCode) > -1 && clientTypeCheck){
            if (type === "custom") {
                filename = `Historical-Share-Prices-${shareClass.clientCode}-${moment(this.state.startDate).format("YYYY-MM-DD")}-to-${moment(this.state.endDate).format("YYYY-MM-DD")}`;
                startDate = moment(this.state.startDate).format("YYYY-MM-DD");
                endDate = moment(this.state.endDate).format("YYYY-MM-DD");
            }
            if (type === "lastMonth") {
                filename = `Historical-Share-Prices-${shareClass.clientCode}-Last-Month`;
                startDate = moment().subtract(1, "day").subtract(1, "month").format("YYYY-MM-DD");
                endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
            if (type === "sixMonths") {
                filename = `Historical-Share-Prices-${shareClass.clientCode}-Last-Six-Months`;
                startDate = moment().subtract(1, "day").subtract(6, "month").format("YYYY-MM-DD");
                endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
        } else {
            if (type === "custom") {
                filename = `Historical-Prices-${shareClass.clientCode}-${moment(this.state.startDate).format("YYYY-MM-DD")}-to-${moment(this.state.endDate).format("YYYY-MM-DD")}`;
                startDate = moment(this.state.startDate).format("YYYY-MM-DD");
                endDate = moment(this.state.endDate).format("YYYY-MM-DD");
            }
            if (type === "lastMonth") {
                filename = `Historical-Prices-${shareClass.clientCode}-Last-Month`;
                startDate = moment().subtract(1, "day").subtract(1, "month").format("YYYY-MM-DD");
                endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
            if (type === "sixMonths") {
                filename = `Historical-Prices-${shareClass.clientCode}-Last-Six-Months`;
                startDate = moment().subtract(1, "day").subtract(6, "month").format("YYYY-MM-DD");
                endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
        }

        if (!isNullOrUndefined(historicalNavData) && clientCodeList.indexOf(clientCode) > -1 && clientTypeCheck){
            if (type === "custom") {
                filename = `Historical-Nav-Prices-${shareClass.clientCode}-${moment(this.state.startDate).format("YYYY-MM-DD")}-to-${moment(this.state.endDate).format("YYYY-MM-DD")}`;
                startDate = moment(this.state.startDate).format("YYYY-MM-DD");
                endDate = moment(this.state.endDate).format("YYYY-MM-DD");
            }
            if (type === "lastMonth") {
                filename = `Historical-Nav-Prices-${shareClass.clientCode}-Last-Month`;
                startDate = moment().subtract(1, "day").subtract(1, "month").format("YYYY-MM-DD");
                endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
            if (type === "sixMonths") {
                filename = `Historical-Nav-Prices-${shareClass.clientCode}-Last-Six-Months`;
                startDate = moment().subtract(1, "day").subtract(6, "month").format("YYYY-MM-DD");
                endDate = moment().subtract(1, "day").format("YYYY-MM-DD");
            }
        }

        if (historicalPrices) {
            let sortedPrices = historicalPrices[0].values.sort((a, b) => {
                const aValue = new Date(a.date).getTime();
                const bValue = new Date(b.date).getTime();
                return aValue - bValue;
            });
            for (let value of sortedPrices) {
                if (moment(value.date).isBetween(startDate, endDate, null, '[]')) {
                    rows.push([
                        shareClass.properties["fund_name"],
                        shareClass.properties.shareclass_name,
                        shareClass.properties["currency"],
                        shareClass.clientCode,
                        moment(value["date"]).format("DD.MM.YYYY"),
                        value["dealing_price_basis"] === "" ? value["dealing_price_basis"] : value["shareclass_price"],
                        value["local_bid_price"],
                        value["local_offer_price"],
                    ]);
                }
            }
        }
        rows.reverse();
        rows.unshift(csvHeadings);
        addItemToGoogleTracking(appParams, "fund_historic_prices_ppl", { eventCategory: shareClass.clientCode, eventLabel: `csv-${type}` });
        exportToCsv(filename, rows);
        this.props.toggleModal();
    }

    checkDate(current) {
        let { shareClass } = this.props.modals;
        if (shareClass) {
            let startDate = moment(shareClass.properties["launch_date"]).format("YYYY-MM-DD");
            let endDate = moment().format("YYYY-MM-DD");
            return moment(current).isBetween(startDate, endDate, null, '[]')
        }
    }

    render() {
        let { modals } = this.props;
        let { shareClass, showModal } = modals;
        if (!shareClass) {
            return <div></div>;
        }
        let internalClass = showModal ? styles.active : '';

        return (
            <div className={`${styles.container} ${internalClass}`}>
                <div className={styles.modalBackground} onClick={() => this.hide()}></div>
                <section className={styles.modal}>
                    <div className={styles.closeModal}><FaClose onClick={() => this.hide()} /></div>
                    <div className={styles.row}>
                        <div className={styles.colXs12 + ' ' + styles.colMd6}>
                            <div className={styles.row}>
                                <div className={styles.colXs12 + ' ' + styles.colMd6}>
                                    <p>Last month</p>
                                    <div>
                                        <button
                                            type="button"
                                            className={styles.tabButtons}
                                            onClick={(event) => this.exportCSV(event, "lastMonth")}>
                                            DOWNLOAD CSV
                                            <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                        </button>
                                        <button
                                            type="button"
                                            className={styles.tabButtons}
                                            onClick={(event) => this.downloadPdf(event, "lastMonth")}>
                                            DOWNLOAD PDF
                                            <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                        </button>
                                    </div>
                                </div>
                                <div className={styles.colXs12 + ' ' + styles.colMd6 + ' ' + styles.colBorder}>
                                    <p>Last 6 months</p>
                                    <div>
                                        <button
                                            type="button"
                                            className={styles.tabButtons}
                                            onClick={(event) => this.exportCSV(event, "sixMonths")}>
                                            DOWNLOAD CSV
                                            <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                        </button>
                                        <button
                                            type="button"
                                            className={styles.tabButtons}
                                            onClick={(event) => this.downloadPdf(event, "sixMonths")}>
                                            DOWNLOAD PDF <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.colXs12 + ' ' + styles.colMd6 + ' ' + styles.customDates}>
                            <p>Custom dates</p>
                            <div className={styles.row}>
                                <div className={styles.colXs6 + ' ' + styles.colMd6}>
                                    <Datetime
                                        isValidDate={this.checkDate}
                                        value={this.state.startDate}
                                        onChange={this.setStartDate}
                                        className="calendarOpen"
                                        inputProps={{ placeholder: "From" }}
                                        timeFormat={false}
                                        dateFormat="DD/MM/YYYY"
                                        open={true} />
                                </div>
                                <div className={styles.colXs6 + ' ' + styles.colMd6}>
                                    <Datetime
                                        isValidDate={this.checkDate}
                                        value={this.state.endDate}
                                        onChange={this.setEndDate}
                                        className="calendarOpen"
                                        inputProps={{ placeholder: "To" }}
                                        dateFormat="DD/MM/YYYY"
                                        timeFormat={false} open={true} />
                                </div>
                                <button
                                    type="button"
                                    className={styles.tabButtons}
                                    onClick={(event) => this.exportCSV(event, "custom")}>
                                    DOWNLOAD CSV
                                    <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                </button>
                                <button
                                    type="button"
                                    className={styles.tabButtons}
                                    onClick={(event) => this.downloadPdf(event, "custom")}>
                                    DOWNLOAD PDF
                                    <FaAngleRight style={{ fontSize: "18px", marginTop: "-3px" }} />
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/HistoricalPricesModal/HistoricalPricesModal.tsx